<section data-step="8" class="step">
    <div class="newchapter">
        <h1 class="chapter">VII. Aan het einde</h1>
        <h2 class="chaptersubtitle">Afgelost of niet afgelost</h2>
    </div>

    <div class="row">
        <div class="twelve columns">
            <p>Na [35] jaar ben je - wat je situatie ook is - klaar met de studiefinanciering. Als je je aan de regels hebt gehouden wordt op dit moment alles wat nog openstaat kwijtgescholden en mag je stoppen met aflossen. Heb je extra afgelost om sneller klaar te zijn, dan ben je eerder verlost van je studieschuld!</p>
        </div>
    </div>

    <div class="row">
        <div class="twelve columns">
            <h2>Eerder aflossen of toch afwachten?</h2>
            <p>De studiefinanciering is geen lening die je bij een bank kunt krijgen. Een bank zal altijd al het geld wat het uitleent terug willen krijgen. Daarom is het bij de bank meestal verstandig om sneller af te lossen, zo voorkom je dat je meer moet betalen door rente.
                De kwijtschelding na de aflosfase door de overheid is uniek en betekent dat het soms juist onverstandig kan zijn om meer te betalen dan je per maand verplicht bent om over te maken.</p>
            <p>De beslissing over hoe veel geld je extra wilt overmaken zul je zelf moeten maken. Wat verstandig is hangt onder andere af van hoe hoog je schuld is, hoe hoog de rente is, hoeveel loon je verdient en verwacht te verdienen,  maar ook van hoe comfortabel je zelf bent met je financiële situatie. 
                Met de grafiek hieronder kun je een indruk krijgen van welke impact deze factoren kunnen hebben op je totale aflossing.
                </p>
            </div>
    </div>
</section>